import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import SplitButton from 'react-bootstrap/SplitButton';
import Dropdown from 'react-bootstrap/Dropdown';
import CalendarSearch from './CalendarSearch';

import { useState, useContext, useEffect } from "react";
import { currentSearch } from "../contexts/Search";

const LAST_SEARCH_BY_KEY = 'last-search-by';
const LAST_SEARCH_TERM_KEY = 'search-term';
const MODE_KEY = 'search';
const SEARCH_BY = {
    ATTACHMENTS: { key: 'attachment', label: 'Search Attachments' },
    DATE: { key: 'postTime', label: 'Search By Date' },
    USERNAME: { key: 'postUsername', label: 'Search Username' },
    SUBJECT: { key: 'postSubject', label: 'Search Topics' },
    POST: { key: 'postText', label: 'Search Posts' },
    FORUM: { key: 'forumName', label: 'Search Forums' },
    ALL: { key: 'all', label: 'Search All' },
    LAST: { key: 'last' }
}



function Search() {
    const { query, setQuery, clearSearch } = useContext(currentSearch);
    const [lastSearchBy, setLastSearchBy] = useState(SEARCH_BY.ALL.label);
    const [searchTerm, setSearchTerm] = useState(localStorage.getItem(LAST_SEARCH_TERM_KEY) || '');
    const [showCalendarSearch, setShowCalendarSearch] = useState(false);

    function getLastSearchedColumn(col) {
        if (col === SEARCH_BY.LAST.key) {
            col = localStorage.getItem(LAST_SEARCH_BY_KEY);
        }
        if (!col) {
            col = SEARCH_BY.ALL.key
        }
        localStorage.setItem(LAST_SEARCH_BY_KEY, col)

        const { label } = SEARCH_BY[Object.keys(SEARCH_BY).find(key => {
            const item = SEARCH_BY[key];
            return item.key === col
        })];
        setLastSearchBy(label || lastSearchBy);
        return col;
    }

    function handleSearchBy(columnName) {
        return (e) => {
            e.preventDefault();
            const col = getLastSearchedColumn(columnName)
            setQuery({ ...query, col, term: searchTerm, page: 1, mode: MODE_KEY, to: null, from: null });
        }
    }

    function onSearchInput(term) {
        localStorage.setItem(LAST_SEARCH_TERM_KEY, term);
        setSearchTerm(term)
    }

    function onClearSearch() {
        localStorage.removeItem(LAST_SEARCH_BY_KEY);
        localStorage.removeItem(LAST_SEARCH_TERM_KEY);
        setSearchTerm('')
        clearSearch();
        localStorage.setItem(LAST_SEARCH_BY_KEY, SEARCH_BY.ALL.key);
    }

    function onCalendarChange(range) {
        const [from, to] = range;
        const col = getLastSearchedColumn(SEARCH_BY.DATE.key);
        setQuery({ ...query, term: searchTerm, col, page: 1, mode: MODE_KEY, from, to });
        setShowCalendarSearch(false)
    }

    useEffect(() => {
        if ( searchTerm?.length > 2 ) {
            const col = getLastSearchedColumn(SEARCH_BY.LAST.key);
            setQuery({ ...query, col, term: searchTerm, page: 1, mode: MODE_KEY });
        }
        // eslint-disable-next-line
    }, [searchTerm, query.term]);

    return (
        <>
            <InputGroup className="search-input-area">
                <button 
                    type='button' 
                    className='btn-clear-search btn btn-norm' 
                    title='Clear Search'
                    disabled={!searchTerm}
                    onClick={e => onClearSearch()}>
                    <i className="fa-lg fa-light fa-broom-wide"/>
                </button>
                <Form.Control
                    aria-label="Search NORM Archives"
                    placeholder={lastSearchBy}
                    value={searchTerm}
                    onChange={e => onSearchInput(e.target.value)}
                />
                <SplitButton
                    variant="norm"
                    title={lastSearchBy}
                    id="search-dropdown"
                    alignRight
                    onClick={handleSearchBy(SEARCH_BY.LAST.key)}
                >
                    <Dropdown.Item
                        onClick={handleSearchBy(SEARCH_BY.ALL.key)}>
                        {SEARCH_BY.ALL.label}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={handleSearchBy(SEARCH_BY.POST.key)}>
                        {SEARCH_BY.POST.label}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={handleSearchBy(SEARCH_BY.FORUM.key)}>
                        {SEARCH_BY.FORUM.label}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={handleSearchBy(SEARCH_BY.SUBJECT.key)}>
                        {SEARCH_BY.SUBJECT.label}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={handleSearchBy(SEARCH_BY.USERNAME.key)}>
                        {SEARCH_BY.USERNAME.label}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={handleSearchBy(SEARCH_BY.ATTACHMENTS.key)}>
                        {SEARCH_BY.ATTACHMENTS.label}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={e => setShowCalendarSearch(true)}>
                        {SEARCH_BY.DATE.label}
                    </Dropdown.Item>
                </SplitButton>
            </InputGroup>
            <CalendarSearch
                showCalendarSearch={showCalendarSearch}
                onSearch={onCalendarChange}
                onCancel={() => setShowCalendarSearch(false)}
            />

        </>
    )
}

export default Search;